import { db } from '@/assets/js-on/firebaseConfig';
const btoa = require('btoa');
const atob = require('atob');

export function url_shortener(des_url) {
  // Using Axios
  // Write logic to retrieve from Firestore - We will get from firestore and
  // store the results in an object
  let index = 0;
  let err = false;
  let fireResults = [];
  let urlObj = {};

  // Get all existing documents from firebase
  async function doShorten() {
    await db.collection("short_url").get()
      .then((q) => {
        q.forEach((doc) => {
          fireResults.push(doc.data()); // Populate fireResults with data
        })
      }).catch((error) => err = true);

      index = fireResults.length;

    urlObj = { // Create a model for new data
      id: index + 1,
      longURL: des_url,
      createdAt: Date.now()
    };

    let enc = btoa(urlObj.id); // This is outside due to javscript limitations
    if(enc.indexOf('=') > 0){
      enc = enc.substring(0, enc.indexOf('='));
    }
    urlObj.shortURL = enc;
    console.log(urlObj.shortURL);

    if(fireResults.length < 1) {
      pushToFirestore();
    }

    for(let el=0; el<fireResults.length; el++) {
      // Iterate through all the results and check if URL already exists
      if(fireResults[el].longURL === des_url) {
        // If the URL already exists, return the URL
        urlObj = fireResults[el];
        return urlObj;
      } else {
        console.log("Creating new URL Object...");
        // Else push to firestore and return the created Url object
        pushToFirestore();
        // then
        if(err) {
          return false;
        } else {
          return urlObj;
        }

      }
    }
  }

    function pushToFirestore() {
      // Logic to update firestore with new urlObj
      db.collection("short_url").doc(urlObj.id.toString()).set({
        longURL: urlObj.longURL,
        shortURL: urlObj.shortURL,
        createdAt: urlObj.createdAt
      })
      .then(()=>{
        console.log("saved");
      })
      .catch((error) => {
        console.error(error);
        err = true
      });
    }

    let returnVariableToRuleThemAll = doShorten();
    return returnVariableToRuleThemAll;

}

export function url_decode(url) {
  let fireResults = [];
  let err = false;  

  async function doDecode() {
    await db.collection("short_url").where("shortURL", "==", url).get()
      .then((q) => {
        q.forEach((doc) => {
          fireResults.push(doc.data()); // Populate fireResults with data
        })
      }).catch((error) => err = true);

    return fireResults[0];
  }

  let anotherVariableThatWillRuleTheFirstVariable = doDecode();
  return anotherVariableThatWillRuleTheFirstVariable;
}



// WEBPACK FOOTER //
// ./src/assets/js-on/url_shortener.js